// extracted by mini-css-extract-plugin
module.exports = {"link":"SeoLink__link"};